export const ModalChangeEmailTranslationsCs = {
  changeEmailMessage:
    'Potvrzovací e-mail pro změnu e-mailu byl odeslán na {{email}}. Prosím, zkontrolujte svou schránku a postupujte podle pokynů pro potvrzení.',
  changeEmailTitle: 'Změnit e-mail',
  enterEmailLabel: 'Zadejte svou e-mailovou adresu',
  emailPlaceholder: 'example@gmail.com',
  'Email in use': 'Ups, tento e-mail je již zabraný!',
  saveButton: 'Uložit',
};
